import Button from "../../../../stories/Components/Button/index";
import { ButtonTypes } from "../../../../stories/Components/Button/interface";
import { ChipProps } from "../../../../stories/Components/Chip/interface";
import classes from "./preferenceDialog.module.scss";
import Modal from "../../../../stories/Components/Modal";
import colors from "../../../../stories/sass/modules/_colors.module.scss";
import { setUserSelections } from "../../utils";
import PreferenceItems from "./preferenceItems";
import { ModalTypes } from "../../../../stories/Components/Modal/interface";
interface PreferenceDialogProps {
    title: string;
    preferenceItems: ChipProps[];
    isOpen: boolean;
    resetClickHandler: () => void;
    saveClickHandler: () => void;
    closeClickHandler: () => void;
}

const PreferenceDialog = ({
    preferenceItems,
    isOpen,
    resetClickHandler,
    saveClickHandler,
    closeClickHandler,
}: PreferenceDialogProps) => {
    const handleSave = () => {
        const chosenItems = preferenceItems.filter((item) => item.active);
        setUserSelections(chosenItems);
        saveClickHandler();
    };

    const propsForModalType = {
        title: "My Shortcuts",
        backgroundColor: colors.neutral20,
    };

    return (
        <Modal
            isOpen={isOpen}
            handleClose={closeClickHandler}
            type={ModalTypes.MODAL_WITH_TITLE_AND_CLOSE}
            propsForModalType={propsForModalType}
        >
            <div
                className={classes.preferenceDialog}
                data-testid="preference-dialog"
            >
                <PreferenceItems preferenceItems={preferenceItems} />

                <div className={classes.buttonContainer}>
                    <Button
                        type={ButtonTypes.TextButton}
                        variant="outlined"
                        label="Reset All"
                        onClick={resetClickHandler}
                    />
                    <Button
                        type={ButtonTypes.TextButton}
                        variant="filled"
                        label="Save & Close"
                        onClick={() => handleSave()} // close the modal after saving
                    />
                </div>
            </div>
        </Modal>
    );
};

export default PreferenceDialog;
